
const messages = {
    en: {
       delivery: {
          ingredient: { 
            name: 'Ingredient',
            title: 'Ingredient management',
            subtitle: 'View, search, create, edit and delete Ingredient',
            creating: 'Creating Ingredient',
            editing: 'Editing Ingredient',
            deleting: 'Deleting Ingredient',
            showing: 'Showing Ingredient',
            menu: 'Ingredient',
            labels: {
                name: 'Name'
            },
          
          }
       }
    },
    es: {
       delivery: {
          ingredient: { 
            name: 'Ingredient',
            title: 'Administración de Ingredient',
            subtitle: 'Ver, buscar, crear, editar, y borrar Ingredient',
            creating: 'Creando Ingredient',
            editing: 'Modificando Ingredient',
            deleting: 'Eliminando Ingredient',
            showing: 'Detalles de Ingredient',
            menu: 'Ingredient',
            labels: {
                name: 'Nombre'
            },
          
          }
       }
    },
    pt: {
       delivery: {
          ingredient: { 
            name: 'Ingredient',
            title: 'Administração de Ingredient',
            subtitle: 'Ver, buscar, criar, editar e usar Ingredient',
            creating: 'Criando Ingredient',
            editing: 'Edição Ingredient',
            deleting: 'Apagando Ingredient',
            showing: 'Detalhes do Ingredient',
            menu: 'Ingredient',
            labels: {
                name: 'Nome'
            },
          
          }
       }
    }
}

export default messages
    